<template>
  <div id="train" class="exam">
    <div class="left">
      <div class="exam-con">
        <div class="content">
          <template v-for="(l, QIndex) in groupRecordList">
            <div class="type">
              <div class="title">
                <p>{{ getNum(QIndex) }}、{{ l.title }}（共{{ l.questionRecordFullList.length }}题，每题{{l.eachScore}}分）</p>
              </div>
              <div class="list" v-for="(q, index) in l.questionRecordFullList">
                <div v-if="q.answerRecord" :title="q.num">
                  <p>
                    <span v-if="q.answerRecord.answerState == 'Right'" class="right">【正确】</span>
                    <span v-if="q.answerRecord.answerState == 'Wrong'" class="wrong">【错误】</span>
                    <span v-if="q.answerRecord.answerState == 'HalfRight'" class="right">【部分正确】</span>
                    <span v-if="q.answerRecord.answerState == 'Blank'" class="wrong">【未作答】</span>
                    {{ q.num }}、<span v-html=" replaceNToBr(q.answerRecord.question.questionStemString)" :id="q.num"></span>
                  </p>
                  <!--图片-->
                  <div v-if="q.answerRecord.question.imageUrlList && q.answerRecord.question.imageUrlList.length>0">
                      <img style="width:100px;height:100px;" :src="i"  @click="clickImg($event)" v-for="i in q.answerRecord.question.imageUrlList"/>
                  </div>
                  <!--单选题 选项-->
                  <template v-if="q.answerRecord.questionType == 'SingleChoice'">
                    <div class="answer">
                      <p v-for="(value, k) in q.answerRecord.question.choices">
                        <el-radio v-model="q.answerRecord.tjkAnswer" :label="k" class="my-disabled">{{ k }}、{{ value }}</el-radio>
                      </p>
                    </div>
                  </template>
                  <!--多选题 选项-->
                  <template v-else-if="q.answerRecord.questionType == 'MultipleChoice'">
                    <div class="answer">
                      <el-checkbox-group v-model="q.answerRecord.tjkAnswer" class="my-disabled">
                        <p v-for="(value, k) in q.answerRecord.question.choices">
                          <el-checkbox :label="k">{{ k }}、{{ value }}</el-checkbox>
                        </p>
                      </el-checkbox-group>
                    </div>
                  </template>
                  <!--判断题 选项-->
                  <template v-else-if="q.answerRecord.questionType == 'TrueOrFalse'">
                    <div class="answer">
                      <el-radio-group v-model="q.answerRecord.tjkAnswer" class="my-disabled">
                        <p><el-radio :label="true">正确</el-radio></p>
                        <p><el-radio :label="false">错误</el-radio></p>
                      </el-radio-group>
                    </div>
                  </template>
                  <!--<template v-if="q.answerRecord.answerState != 'Right'">
                    <div class="answer">
                      正确答案：
                      <template v-if="q.answerRecord.questionType == 'SingleChoice'">
                        {{q.answerRecord.question.rightAnswer}}
                      </template>
                      <template v-else-if="q.answerRecord.questionType == 'MultipleChoice'">
                        <span v-for="(value, k) in q.answerRecord.question.rightAnswer">
                          {{ value }}
                        </span>
                      </template>
                      <template v-else-if="q.answerRecord.questionType == 'TrueOrFalse'">
                        {{q.answerRecord.question.rightAnswer == 'true' ? '正确' : '错误'}}
                      </template>

                    </div>
                  </template>-->
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
    <div class="right">
      <div class="count">
        <h2>统计</h2>
        <div class="useTime">
          <!--<p>距自动交卷时间</p>-->
          <span class="blue">{{examRecord.score >= exam.passScore ? '通过':'未通过'}}</span>
        </div>
        <div class="useTime">
          <p class="txt">得分：{{examRecord.score}}</p>
        </div>
        <div class="useTime">
          <p class="txt">通过分数：{{exam.passScore}}</p>
        </div>
        <ul>
          <template v-for="(l, QIndex) in groupRecordList">
            <template v-for="(q, qIndex) in l.questionRecordFullList">
              <li :class="{active2:q.answerRecord.answerState == 'Right', active4:q.answerRecord.answerState != 'Right'}"><a :href="'#'+q.num">{{ q.num }}</a></li>
            </template>
          </template>
        </ul>
        <div class="btn">
          <div class="hold" @click="exitExam">继续测试</div>
          <div class="hold" @click="relearn">重新学习</div>
        </div>
      </div>
    </div>
    <zoom-img v-if="showImg" @clickit="viewImg" :imgSrc="imgSrc"></zoom-img>
  </div>
</template>

<script>
    import zoomImg from '../../components/zoomImg.vue'
    export default {
        data() {
            return {
                examRecordId: this.$route.params.id,//examRecordId
                groupRecordList: [], //试题信息
                examRecord: {}, //淘金客答题记录信息
                exam: {}, //考试课程信息


                courseId: this.$route.query.courseId, //课程id
                type: this.$route.query.type, //上级tab类型
                majorId: this.$route.query.majorId, //技能提升-场景-课程id
                passScore: null, //通关分数
                show: this.$route.query.show, //技能提升-场次和场景列表切换标识
                endTime: '',
                time: '',
                showImg: false,
                imgSrc: '',
                num: [],
                savelist: [],
                list: [], //保存时的结果集转换的一维数组，用作答题卡
                showExamError:false, //显示 错题集开关
                score:null,//考试分数
                state:'',//考试是否通过（状态）
                times:null,//剩余考试次数
                Coursename:'',//当前课程名称
                nextobject:{},//储存当前课程接口返回
                nextCoursename:'',//下一个课程名称
                Coursestate:'',//下一个课程的类型（英文）
                Coursestatename:'',//下一个课程的类型（中文）
                categoryName:'',//当前tab名字
                nextcategoryName:'',//下一个tab名字
                tabstate:null,//tab状态
                nextcourseId:null,//查询下一个知识点id
                tabIndex:null,//当前所在tab位置
                huizhang:'',//徽章名字
                theory:this.$route.query.theory,//在线理论跳考试
                knowledgestate:null,//弹窗文字类型
                knowledgename:'',//当前知识点或课程名称
                dazhiJump:false,//打字认证跳系统实操
                trainFlag:this.$route.query.trainFlag,//判断是不是理论跳转考试
                sceneId:this.$route.query.sceneId,
                trainId:this.$route.query.trainId,
                tjkId:this.$route.query.tjkId
            }
        },
        components: {
            'zoom-img': zoomImg
        },
        created() {
            this.examRecordId = this.$route.params.id;
        },
        mounted() {
            this.getPaper(this.examRecordId)
        },
        methods: {
            //试卷内容查询
            getPaper(examRecordId) {
                var self = this;
                var data = {
                    'examRecordId': examRecordId
                }
                this.$http.post(API_ROOT.college + '/examRecord/getTjkExamDetail', data).then(response => {
                    var result = response.data
                    if(result.success) {
                        self.groupRecordList = result.data.groupRecordList
                        self.examRecord = result.data.examRecord
                        self.exam = result.data.exam
                        //groupRecordList标记好题号
                        var num = 1;
                        for(var i = 0; i < self.groupRecordList.length; i++){
                            var questionRecordFullList = self.groupRecordList[i];
                            for(var j = 0; j < questionRecordFullList.questionRecordFullList.length; j++){
                                questionRecordFullList.questionRecordFullList[j].num = num;
                                num++;
                            }
                        }
                    }else {
                        this.$alert(result.msg)
                    }
                }, response => {
                    this.$alert('网络繁忙，请稍后重试！')
                })
            },



            //报名或参加下一个tab
            goindex(){
                this.$router.push({path:'/train/index'})
            },
            //点击继续（学习，练习，测试）
            determine(){
                if(this.nextobject.next && !this.nextobject.nextCourse && !this.nextobject.nextCategory ){
                    this.nextcourseId=this.nextobject.next.courseId
                    window.location.href ="/tjkStudy/vedioDetail?courseId=" +this.nextcourseId+'&knowledgeSeq='+this.nextobject.next.knowledgeSeq+'&CourseLevel='+this.CourseLevel+'&sceneId='+this.$route.query.sceneId+'&assitantTjkId='+this.$route.query.tjkId+'&tjkId='+this.$route.query.tjkId+'&trainId='+this.$route.query.trainId+'&knowledgeId='+this.knowledgeId
                }else if(!this.nextobject.nextCategory  &&  this.nextobject.nextCourse &&  this.nextobject.next){
                    this.nextcourseId=this.nextobject.nextCourse.courseId
                    this.toStudy()
                }else if(!this.nextobject.nextCategory  &&  this.nextobject.nextCourse){
                    this.nextcourseId=this.nextobject.nextCourse.courseId
                    this.gotoStudy()
                } else if (this.nextobject.nextCategory) {
                    this.$router.push({path: '/train/index'})
                } else if (!this.nextobject.next && !this.nextobject.nextCourse && !this.nextobject.nextCourse) {
                    this.$router.push({path: '/train/index'})
                }
            },
            gotoStudy() {


                this.$http.post(API_ROOT.college + "/course/getKnowledgeListXlk",{courseId:this.nextcourseId})
                    .then(
                        (res) => {
                            var result = res.data;
                            if (result.success) {
                                if(result.data.knowledgeRecordFullList.length!=1 && result.data.knowledgeRecordFullList.length!=0) {
                                    this.$router.push({path:'/train/Secondarylist',query:{courseId:this.nextcourseId

                                        }})
                                }else if(this.CourseLevel==3){


                                    this.$router.push({
                                        path:'/train/SpecialCourses',query:{
                                            sceneId:this.$route.query.sceneId,
                                            trainId:this.$route.query.trainId,
                                            tjkId:this.$route.query.tjkId,
                                            assitantTjkId:this.$route.query.tjkId

                                        }
                                    })
                                }


                                else{
                                    this.tabIndex=localStorage.getItem('tabIndex')

                                    this.$router.push({
                                        path:'/train/index',
                                        query:{
                                            tabIndex:this.tabIndex,
                                            condition:true//判断是否是基础知识点跳课程
                                        }
                                    })
                                }
                            } else {
                                if(result.msg != null && result.msg !=''){
                                    this.$alert(result.msg);
                                }
                            }
                        },
                        (res) => {
                            this.$alert(
                                "AJAX请求接口异常（/assitantTrain/saveWebLoginAndAssitantDown）！"
                            );
                        }
                    );
            },
            toStudy() {
                console.log(this.CourseLevel,'状态')

                this.$http.post(API_ROOT.college + "/course/getKnowledgeListXlk",{courseId:this.nextcourseId})
                    .then(
                        (res) => {
                            var result = res.data;
                            if (result.success) {
                                if(result.data.knowledgeRecordFullList.length!=1 && result.data.knowledgeRecordFullList.length!=0) {
                                    this.$router.push({path:'/train/Secondarylist',query:{courseId:this.nextcourseId}})
                                }else if(this.CourseLevel==3){
                                    this.$router.push({
                                        path:'/train/SpecialCourses',query:{
                                            sceneId:this.$route.query.sceneId,
                                            trainId:this.$route.query.trainId,
                                            tjkId:this.$route.query.tjkId,
                                            assitantTjkId:this.$route.query.tjkId
                                        }
                                    })
                                }else if(result.data.knowledgeRecordFullList.length==1){
                                    window.location.href='/tjkStudy/vedioDetail?courseId='+this.nextcourseId+'&knowledgeSeq='+this.nextobject.next.knowledgeSeq+'&CourseLevel='+this.CourseLevel+'&sceneId='+this.$route.query.sceneId+'&assitantTjkId='+this.$route.query.tjkId+'&tjkId='+this.$route.query.tjkId+'&trainId='+this.$route.query.trainId+'&knowledgeId='+this.knowledgeId
                                }
                            } else {
                                if(result.msg != null && result.msg !=''){
                                    this.$alert(result.msg);
                                }
                            }
                        },
                        (res) => {
                            this.$alert(
                                "AJAX请求接口异常（/assitantTrain/saveWebLoginAndAssitantDown）！"
                            );
                        }
                    );
            },
            //考试页面查看下一个课程
            seecurriculum() {
                var data = {
                    'courseId': this.courseId,
                }
                this.$http.post(API_ROOT.college + '/course/getGuideDialog', data).then(response => {
                    var result = response.data;
                    if (result.success) {
                        this.knowledge=result.data.current
                        this.nextobject=result.data
                        if(this.nextobject.next){this.knowledgeId=this.nextobject.next.knowledgeId}


                        if(this.nextobject.next && !this.nextobject.nextCourse && !this.nextobject.nextCategory){
                            this.knowledgestate=1//知识点跳知识点
                            this.knowledgeId=this.nextobject.next.knowledgeId
                            this.knowledgename=this.nextobject.current.title
                        }else if(!this.nextobject.nextCategory  &&  this.nextobject.nextCourse){

                            this.knowledgestate=2//知识点跳课程
                            this.knowledgename=this.nextobject.currentCourse.courseName

                            if(this.nextobject.nextCourse.courseType=='Exam' || this.nextobject.nextCourse.assitantType=='AssitantSpecialRobotExam'){
                                this.Coursestate='Exam'
                            }else if(this.nextobject.nextCourse.courseType=='Integrate' && this.nextobject.nextCourse.assitantType){

                                this.Coursestate='Practice'
                            }else if(this.nextobject.nextCourse.courseType=='Integrate' && !this.nextobject.nextCourse.assitantType){

                                this.Coursestate='Study'
                            }
                        }else if(this.nextobject.nextCategory){
                            this.knowledgestate=2
                            this.categoryName=this.nextobject.currentCategory.categoryName
                        }else if(!this.nextobject.next && !this.nextobject.nextCourse && !this.nextobject.nextCategory){
                            this.knowledgestate=2
                        }

                        var  ismajorId=localStorage.getItem('majorId')
                        this.$http.post(API_ROOT.college + "/courseCategory/queryListXlk",{majorId:ismajorId}).then((res) => {
                            var result = res.data;

                            if (result.success) {
                                let relist=result.data
                                if(!this.nextobject.next && !this.nextobject.nextCourse && !this.nextobject.nextCategory){
                                    this.knowledgestate=2
                                    this.categoryName=this.nextobject.currentCategory.categoryName
                                    this.tabstate=1
                                }else if(this.nextobject.nextCategory){
                                    if(this.nextobject.nextCategory==null){
                                    }else{

                                        this.tabstate=2
                                        this.nextobject.nextCategory.assitantType
                                        relist.forEach((item,index) => {
                                            if(item.assitantType==this.nextobject.nextCategory.assitantType){
                                                if(this.nextobject.nextCategory.assitantType=='OnlineUpgradeSkill'){

                                                    localStorage.setItem('tabIndex',index)
                                                    localStorage.setItem('majorId',item.majorId)
                                                    if(this.nextobject.theoryBadge==false){
                                                        this.nextcategoryName='理论培训'
                                                    }else{
                                                        this.nextcategoryName='实操培训'
                                                    }
                                                }else if(this.nextobject.nextCategory.assitantType=='VoiceUpgradeSkill'){
                                                    localStorage.setItem('tabIndex',index)
                                                    localStorage.setItem('majorId',item.majorId)
                                                    this.nextcategoryName='语音技能提升'
                                                }else if(this.nextobject.nextCategory.assitantType=='SysOperate'){
                                                    this.dazhiJump=true
                                                    localStorage.setItem('tabIndex',index)
                                                    localStorage.setItem('majorId',item.majorId)
                                                    localStorage.setItem('categoryId',item.categoryId)

                                                }else{
                                                    localStorage.setItem('tabIndex',index)
                                                    localStorage.setItem('majorId',item.majorId)
                                                    localStorage.setItem('categoryId',item.categoryId)
                                                    this.categoryName=this.nextobject.currentCategory.categoryName
                                                    this.nextcategoryName==item.categoryName
                                                }
                                            }
                                        })
                                    }
                                }

                            } else {
                                if(result.msg != null && result.msg !=''){
                                    this.$alert(result.msg);
                                }
                            }
                        }, (res) => {
                            this.$alert(
                                "AJAX请求接口异常（/assitantTrain/saveWebLoginAndAssitantDown）！"
                            );
                        })
                    }else {
                        if(result.msg != null && result.msg !=''){
                            this.$alert(result.msg);
                        }
                    }
                }, response => {
                    this.$alert('AJAX请求接口异常（/examining/startExam）！');
                })
            },
            replaceNToBr(str) {
                var reg = new RegExp("\n", "g");
                return str.replace(reg, "<br/>");
            },
            //考试时间提示框
            open() {
                const h = this.$createElement;
                this.$notify({
                    title: '',
                    message: h('i', { style: 'color: red'}, '离自动交卷还有5分钟，请注意答题时间'),
                    duration: 5000
                })
            },
            //点击继续测试
            exitExam(){
                if(this.trainFlag == 'theory' && this.times == 0 ) {
                    this.$message({message: '已无剩余测试次数', type: 'warning', center: true, duration: 3000})
                    this.tabIndex = localStorage.getItem('tabIndex')
                    this.$router.push({path: '/train/index', query: {tabIndex: this.tabIndex}})
                    return;
                }
                if(this.trainFlag == 'tjcollege' && this.times == 0 ) {
                    if(this.times == 0){
                        this.$message({message: '已无剩余测试次数', type: 'warning', center: true, duration: 3000})
                    }
                    this.$router.push({path:'/train/SpecialCourses',query:{sceneId:this.sceneId,trainId:this.trainId,tjkId:this.tjkId}})
                    return;
                }
                window.location.href = '/tjkStudy/train/examDetail?courseId='+this.courseId +  '&sceneId=' + this.sceneId+'&trainId=' + this.trainId + '&tjkId='+this.tjkId+'&trainFlag='+this.trainFlag;
            },
            //重新学习
            relearn() {
                var self = this;
                //在线理论考核，点返回，直接返回到培训页，其他的返回上个路由页，包括营销培训
                if(this.trainFlag=='theory'){
                    this.tabIndex=localStorage.getItem('tabIndex')
                    this.$router.push({path:'/train/index',query:{tabIndex:this.tabIndex}})
                }else if(this.trainFlag=='VoiceGraduateExam'){
                    this.$router.push({path:'/train/SpecialCourses',query:{sceneId:this.sceneId,trainId:this.trainId,tjkId:this.tjkId}})
                }else if(this.trainFlag=='fbtTrain'){
                    this.$router.push({path:'/train/index'})
                }else if(this.trainFlag=='tjcollege'){
                    this.$router.push({path:'/train/SpecialCourses',query:{sceneId:this.sceneId,trainId:this.trainId,tjkId:this.tjkId}})
                }else{
                    this.$router.back()
                }
            },
            //获取大题分类序号
            getNum(key) {
                var arry = ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十', '十一', '十二', '十三', '十四', '十五', '十六', '十七', '十八', '十九', '二十'];
                for(var i=0;i<arry.length;i++) {
                    if(i == key) {
                        return arry[i];
                        break;
                    }
                }
            },
            //判断是否显示已答题样式
            getClass(string) {
                if(typeof string == 'boolean') {
                    return true;
                }else if(string instanceof Array) {
                    for(var i=0;i<string.length;i++) {
                        if(string[i] != '') {
                            return true;
                            break;
                        }
                    }
                }else if(string != '') {
                    return true;
                }else {
                    return false;
                }
            },
            clickImg(e) {
                this.showImg = true;
                // 获取当前图片地址
                this.imgSrc = e.currentTarget.src;
            },
            viewImg() {
                this.showImg = false;
            }
        }
    }
</script>

<style lang="less" scoped>
 .my-disabled {
    pointer-events: none;
 }
  #train {
    padding: 0 0 0 20px !important;
  }
  .correct_img{width: 60px;height: 60px;margin: 0 auto;margin-bottom: 10px;}
  .score{font-size: 36px;font-family: Source Han Sans CN;font-weight: bold;color: #497AF2;line-height: 18px;text-align: center;margin-bottom: 20px;}
  .state_text1{font-size: 18px;font-family: Source Han Sans CN;font-weight: 500;color: #262626;line-height: 18px;text-align: center;margin-left:15px;margin-bottom: 11px;}
  .state_text2{font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #262626;
    line-height: 18px;text-align: center;margin-left: 15px;}
  .state_text2> .spanclass{color: #497AF2;}
  /deep/.el-dialog--center{border-radius: 10px;}
  .state_text1_1{background: #FFFFFF;border-radius: 10px;margin-bottom: 11px;color: #262626;text-align: center;font-size: 14px;}
  .failed{font-size: 14px;font-family: Source Han Sans CN;font-weight: 400;color: #262626;line-height: 18px;margin-left: 15px;margin-top: 20px;text-align: center;margin-bottom: 59px;}
  .failed>span{color:#497AF2;}
  .state_text1_2{margin-top: 78px;}
  .badge_box{text-align: center;}
  .badge{margin-top: 31px ;margin-bottom: 40px;width: 209px;
    display: inline-block;
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #262626;
    line-height: 18px;}
  /deep/ .el-dialog--center .el-dialog__body{padding: 25px 25px 0px 30px;}
  /deep/ .el-dialog__footer {padding: 0px 20px 20px 20px;}
  .button_box{display: flex;justify-content: center;}
  .button_box1{text-align: center;}
  .out_button_1{width: 100px;height: 28px;background: #DBE5FF;border-radius: 6px;font-size: 14px;font-family: Source Han Sans CN;font-weight: 500;color: #497AF2;line-height: 28px;margin-right: 10px;cursor: pointer;}
  .out_button_2{width: 100px;height: 28px;background: #497AF2;border-radius: 6px;font-size: 14px;font-family: Source Han Sans CN;font-weight: 500;color: #FFFFFF;line-height: 28px;cursor: pointer;}
  .out_button_3{width: 100px;height: 28px;background: #497AF2;border-radius: 6px;font-size: 14px;font-family: Source Han Sans CN;font-weight: 500;color: #FFFFFF;line-height: 28px;cursor: pointer;margin: 0 auto;}
  .newtext{margin-bottom: 40px;margin-left: 0px !important;}
  .dialog-footer /deep/.el-button{background:#497AF2;color: #fff;}

  .right {
    color: #09ae14;
  }
  .wrong {
    color: #f8370e;
  }
</style>



// WEBPACK FOOTER //
// ./src/page/train/basicExamDetail.vue